/**
 * 🔍 Utilitários de Debug para Sistema de Camadas
 * 
 * Para usar no console do navegador:
 * 
 * 1. Abra o console (F12)
 * 2. Digite: window.debugLayers()
 */

// Função para detectar referências duplicadas de imagens
export const detectDuplicateImageRefs = (uploadedImages) => {
  console.group('🔍 Análise de Referências de Imagem');
  
  const imageRefs = new Map();
  const results = {
    totalLayers: uploadedImages.length,
    uniqueRefs: 0,
    duplicates: []
  };
  
  uploadedImages.forEach((img, i) => {
    if (img.image) {
      const refId = img.image;
      if (!imageRefs.has(refId)) {
        imageRefs.set(refId, []);
      }
      imageRefs.get(refId).push({ 
        index: i, 
        id: img.id, 
        name: img.name || 'sem nome',
        src: img.src?.substring(0, 50) + '...'
      });
    }
  });
  
  results.uniqueRefs = imageRefs.size;
  
  console.log('📊 Total de camadas:', results.totalLayers);
  console.log('📊 Referências únicas:', results.uniqueRefs);
  
  if (results.uniqueRefs < results.totalLayers) {
    console.warn('⚠️ PROBLEMA DETECTADO!');
    console.warn(`   ${results.totalLayers} camadas mas apenas ${results.uniqueRefs} referências únicas`);
    
    imageRefs.forEach((layers, imageRef) => {
      if (layers.length > 1) {
        console.warn('   ❌ Referência compartilhada entre:', layers);
        results.duplicates.push(layers);
      }
    });
    
    console.log('');
    console.log('💡 SOLUÇÃO:');
    console.log('   Delete as camadas duplicadas antigas');
    console.log('   Use o botão de duplicar após a correção');
    console.log('   Cada duplicata terá sua própria referência de imagem');
  } else {
    console.log('✅ TUDO OK! Cada camada tem sua própria referência de imagem');
  }
  
  console.groupEnd();
  return results;
};

// Função para verificar a ordem de renderização
export const checkRenderOrder = (uploadedImages) => {
  console.group('📋 Ordem de Renderização');
  
  console.log('Array uploadedImages (índice → nome):');
  uploadedImages.forEach((img, i) => {
    console.log(`  [${i}] ${img.name || img.id} ${i === 0 ? '← Topo (frente)' : i === uploadedImages.length - 1 ? '← Base (trás)' : ''}`);
  });
  
  console.log('');
  console.log('Ordem de renderização no canvas (invertida):');
  [...uploadedImages].reverse().forEach((img, i) => {
    const originalIndex = uploadedImages.length - 1 - i;
    console.log(`  ${i + 1}º desenhado: [${originalIndex}] ${img.name || img.id} ${i === 0 ? '← Desenha PRIMEIRO (embaixo)' : i === uploadedImages.length - 1 ? '← Desenha POR ÚLTIMO (em cima)' : ''}`);
  });
  
  console.groupEnd();
};

// Função principal de debug
export const debugLayers = (uploadedImages) => {
  console.clear();
  console.log('🔧 ════════════════════════════════════════════════════════');
  console.log('🔧 DIAGNÓSTICO DO SISTEMA DE CAMADAS');
  console.log('🔧 ════════════════════════════════════════════════════════');
  console.log('');
  
  detectDuplicateImageRefs(uploadedImages);
  console.log('');
  checkRenderOrder(uploadedImages);
  
  console.log('');
  console.log('🔧 ════════════════════════════════════════════════════════');
};

// Expor globalmente para uso no console
if (typeof window !== 'undefined') {
  window.debugLayersUtil = {
    detectDuplicateImageRefs,
    checkRenderOrder,
    debugLayers
  };
}

export default {
  detectDuplicateImageRefs,
  checkRenderOrder,
  debugLayers
};

